import styled from 'styled-components';

export const SectionWrap = styled.div `
    padding-top: 60px;
    padding-bottom: 60px;
`;